// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"0d183937","453":"794cc752","833":"79728b57"}[chunkId] + ".chunk.js";
};